import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardOperationalState } from '@api/ruStatusDashboard';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_OPERATIONAL_STATE } from '@constants/queryKeys';

interface IUseQueryRUDashboardStatusOperationalState {
	ruDashboardStatusOperationalState: TSelectOption<string>[];
	isLoadingRUDashboardStatusOperational: boolean;
}

export const useQueryRUDashboardStatusOperationalState = (): IUseQueryRUDashboardStatusOperationalState => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_OPERATIONAL_STATE],
		queryFn: getRUStatusDashboardOperationalState,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'name',
			labelKey: 'title',
		}),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		...refetchOptions,
	});

	return {
		ruDashboardStatusOperationalState: data || [],
		isLoadingRUDashboardStatusOperational: isInitialLoading,
	};
};
